'use client';

import React from 'react';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';

// Backend integration point: replace with /api/collection/string-changes?period=12m
const stringChangeData = [
  { month: 'Jun', changes: 1 },
  { month: 'Jul', changes: 2 },
  { month: 'Aug', changes: 1 },
  { month: 'Sep', changes: 3 },
  { month: 'Oct', changes: 2 },
  { month: 'Nov', changes: 1 },
  { month: 'Dec', changes: 0 },
  { month: 'Jan', changes: 2 },
  { month: 'Feb', changes: 1 },
  { month: 'Mar', changes: 2 },
  { month: 'Apr', changes: 3 },
  { month: 'May', changes: 4 },
];

function CustomTooltip({ active, payload, label }: { active?: boolean; payload?: { value: number }[]; label?: string }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg px-3 py-2 shadow-modal text-sm">
      <p className="font-600 text-foreground">{label} 2025–26</p>
      <p className="text-muted-foreground">{payload[0].value} string change{payload[0].value !== 1 ? 's' : ''}</p>
    </div>
  );
}

export default function StringChangeChart() {
  return (
    <div className="bg-card rounded-2xl p-5 shadow-card border border-border h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-sm font-700 text-foreground">String Changes</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Last 12 months across all guitars</p>
        </div>
        <span className="text-[11px] font-600 px-2 py-0.5 rounded-full bg-accent/10 text-accent">18 total</span>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <AreaChart data={stringChangeData} margin={{ top: 4, right: 0, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="stringGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="var(--accent)" stopOpacity={0.2} />
              <stop offset="95%" stopColor="var(--accent)" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)', fontFamily: 'var(--font-sans)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)', fontFamily: 'var(--font-sans)' }}
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="changes"
            stroke="var(--accent)"
            strokeWidth={2}
            fill="url(#stringGradient)"
            dot={{ fill: 'var(--accent)', r: 3, strokeWidth: 0 }}
            activeDot={{ r: 5, fill: 'var(--accent)', stroke: 'var(--card)', strokeWidth: 2 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}